import './home.css';
import { useEffect, useState, useContext } from 'react';
import { UsersAPI } from '../api';
import { UserContext } from '../context/UserContext';

export default function TeamAPN() {
  const { user } = useContext(UserContext);
  const [mentors, setMentors] = useState([]);
  const [loadingMentors, setLoadingMentors] = useState(false);
  const [mentorError, setMentorError] = useState('');

  useEffect(() => {
    let active = true;
    async function loadMentors() {
      setLoadingMentors(true);
      setMentorError('');
      try {
        // Öffentliche Mentorenliste (keine Auth nötig, sichtbarkeitsbewusst)
        const res = await UsersAPI.publicMentors();
        const arr = Array.isArray(res?.items) ? res.items : [];
        if (active) setMentors(arr);
      } catch (e) {
        if (active) setMentorError('Mentoren konnten nicht geladen werden');
      } finally {
        if (active) setLoadingMentors(false);
      }
    }
    loadMentors();
    return () => { active = false; };
  }, []);

  return (
    <div className="home-page">
      {/* Hero */}
      <section id="top" className={user ? "hero-offset-if-sidebar" : ""} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Das Team des AP‑N</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>
          Menschen mit Leidenschaft für Qualität, Community und nachhaltiges Creator‑Wachstum.
          Hier findest du unser Kernteam.
        </p>
      </section>

      {/* Content */}
      <section style={{ width: '100%', maxWidth: 1100, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        {/* Kernteam */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Kernteam</h2>
          {/* Leitung */}
          <div style={{ marginBottom: 24 }}>
            <h3 style={{ margin:'8px 0', fontFamily:'Montserrat, Arial, sans-serif' }}>Leitung <span style={{ fontSize:18 }} aria-hidden="true">🧭</span></h3>
            <div style={{ display:'flex', gap:12, flexWrap:'wrap' }}>
              <PersonCard name="Alex" alias="Sora / Sora_FL" roleLabel="Leitung" />
              <PersonCard name="Pierre" alias="Red / RedFettHead" roleLabel="Leitung" />
            </div>
          </div>
          {/* Community & Moderation */}
          <div style={{ marginBottom: 24 }}>
            <h3 style={{ margin:'8px 0', fontFamily:'Montserrat, Arial, sans-serif' }}>Community & Moderation <span style={{ fontSize:18 }} aria-hidden="true">🛡️</span></h3>
            <div style={{ display:'flex', gap:12, flexWrap:'wrap' }}>
              <PlaceholderCard label="Mod Platzhalter" />
              <PlaceholderCard label="Mod Platzhalter" />
              <PlaceholderCard label="Mod Platzhalter" />
            </div>
            <div style={{ marginTop:8, fontSize:12, color:'#9ca3af' }}>Wird später mit Details ergänzt.</div>
          </div>
          {/* Mentoring */}
          <div>
            <h3 style={{ margin:'8px 0', fontFamily:'Montserrat, Arial, sans-serif' }}>Mentoring <span style={{ fontSize:18 }} aria-hidden="true">🧑‍🏫</span></h3>
            {loadingMentors && <div style={{ fontSize:13, color:'#9ca3af' }}>Lade Mentoren…</div>}
            {mentorError && <div style={{ fontSize:13, color:'#ef4444' }}>{mentorError}</div>}
            {!loadingMentors && !mentorError && (
              mentors.length > 0 ? (
                <div style={{ display:'flex', gap:12, flexWrap:'wrap' }}>
                  {mentors.map(m => (
                    <PersonCard
                      key={m.id}
                      name={m.displayName || m.username || `User#${m.id}`}
                      alias={''}
                      roleLabel="Mentor"
                    />
                  ))}
                </div>
              ) : (
                <div style={{ fontSize:13, color:'#9ca3af' }}>Noch keine Mentoren gelistet.</div>
              )
            )}
            {/*<div style={{ marginTop:8, fontSize:12, color:'#9ca3af' }}>Mentoren werden automatisch anhand ihrer Rolle angezeigt.</div>*/}
          </div>
        </div>

        {/* Wie wir arbeiten */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Wie wir arbeiten</h2>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Wir arbeiten transparent, mit kurzen Wegen und verlässlichen Absprachen – mit Fokus auf Qualität und langfristige Entwicklung statt kurzer Hypes.
          </p>
          <div style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:12}}>
            {['Transparenz','Kurze Wege','Verlässlichkeit','Qualität'].map((t,i)=>(
              <span key={i} style={{fontSize:12,lineHeight:'20px',padding:'4px 10px',borderRadius:999,border:'1px solid rgba(255,255,255,0.15)',background:'rgba(255,255,255,0.03)',color:'#D4D8DF'}}>{t}</span>
            ))}
          </div>

          <h3 style={{ margin:'14px 0 6px', fontFamily:'Montserrat, Arial, sans-serif', fontSize:16, color:'#E5E7EB' }}>Führungsstruktur & Entscheidungsfindung</h3>
          <p style={{ color:'#D4D8DF', margin:'6px 0' }}>Unser Führungskonzept definiert klare Rollen, Verantwortlichkeiten und Entscheidungsprozesse. Entscheidungen werden transparent und im Sinne der Community getroffen – ohne autoritäre Alleingänge. Wir trennen bewusst zwischen der kostenfreien Community‑Struktur und den kostenpflichtigen Dienstleistungen.</p>

          <div style={{display:'grid',gap:10,gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))',marginTop:10}}>
            <RoleBox title="Administratoren / Leitung">
              Zwei gleichberechtigte Admins vertreten die Community nach außen und übernehmen organisatorische Hauptaufgaben.
            </RoleBox>
            <RoleBox title="Moderatoren (Mods)">
              Unterstützen die Leitung im Alltag, moderieren Plattform & Discord; übernehmen Aufgaben nach Absprache. Einsetzung/Entlassung per Admin‑Mehrheitsbeschluss.
            </RoleBox>
            <RoleBox title="Mentoren">
              Begleiten erste Schritte, helfen beim Setup (Stream & Lurker‑Client), erklären Plattformfunktionen und geben konstruktives Feedback.
            </RoleBox>
            <RoleBox title="Creator / Streamer">
              Vollwertige Mitglieder mit Zugriff auf Support‑Tools, Punkte, Lurker‑Einbindung, Statistiken; Teilnahme an Events, Challenges, Supportplan, Mentoring.
            </RoleBox>
            <RoleBox title="Anwärter">
              Bewerber:innen auf den Creator‑Status mit mehrstufigem Onboarding und eingeschränkten Rechten; Aufnahme per Admin‑Mehrheit (optional Mod/Community‑Votum).
            </RoleBox>
            <RoleBox title="Allgemeine Mitglieder / Community">
              Gäste ohne Voraussetzungen; Zugang zu News, Shops, Servern, Events etc.; kein direkter Einfluss auf Entscheidungen oder Moderation.
            </RoleBox>
          </div>

          <div style={{marginTop:14,padding:'10px 12px',border:'1px solid rgba(50,205,137,0.35)',background:'rgba(50,205,137,0.08)',borderRadius:8}}>
            <p style={{margin:0,color:'#d8f5e8'}}>
              Kostenpflichtige Leistungen: Die Entscheidungsgewalt liegt bei der Leitung. Admins können sich mit Mods beraten, es besteht jedoch keine Abstimmungspflicht. Unternehmerische Entscheidungen (z. B. Lizenzen, Preise, externe Partnerschaften, Creator‑Pakete) liegen exklusiv bei der Leitung; die Community hat hier keinen direkten Einfluss.
            </p>
          </div>

          <p style={{ color:'#D4D8DF', marginTop:12 }}>
            Fazit: Klare Zuständigkeiten, demokratische Entscheidungsfindung und Transparenz – mit einer sinnvollen Trennung zwischen Community‑Verwaltung und unternehmerischer Leitung für Stabilität und Professionalität.
          </p>
        </div>

        {/* Mitmachen/Kontakt */}
        <div className="highlight-card" style={{ padding: 24 }}>
          <h2 className="highlight-title">Mitmachen & Kontakt</h2>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Du willst Teil des Teams werden oder uns unterstützen? Melde dich – wir freuen uns auf engagierte Menschen,
            die unsere Werte teilen.
          </p>
          <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
            <a className="hero-btn-primary" href="/kontakt" style={{ padding: '12px 18px', textDecoration:'none' }}>Kontakt aufnehmen</a>
            <a className="hero-btn-secondary" href="/register" style={{ padding: '12px 18px', textDecoration:'none' }}>Jetzt beitreten</a>
          </div>
          <div style={{ marginTop: 16 }}>
            <a href="#top" style={{ color: '#32CD89' }}>Nach oben</a>
          </div>
        </div>
      </section>
    </div>
  );
}

function PersonCard({ name, alias, roleLabel }) {
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:6, padding:12, border:'1px solid rgba(255,255,255,0.10)', background:'rgba(255,255,255,0.03)', borderRadius:12, minWidth:180 }}>
      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
        <div style={{ width:46, height:46, borderRadius:'50%', background:'linear-gradient(135deg,#1C63D6,#8F5DD4)', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800 }} aria-hidden="true">{(name||'')[0] || '?'}</div>
        <div style={{ minWidth:0 }}>
          <div style={{ fontWeight:700 }}>{name}</div>
          {alias && <div style={{ fontSize:12, color:'#9ca3af' }}>{alias}</div>}
        </div>
      </div>
      <div style={{ fontSize:12, fontWeight:700, color:'#32CD89' }}>{roleLabel}</div>
    </div>
  );
}

function PlaceholderCard({ label }) {
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:6, padding:12, border:'1px dashed rgba(255,255,255,0.15)', background:'rgba(255,255,255,0.025)', borderRadius:12, minWidth:160 }}>
      <div style={{ width:42, height:42, borderRadius:'50%', background:'rgba(255,255,255,0.08)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, color:'#9ca3af' }} aria-hidden="true">…</div>
      <div style={{ fontSize:12, color:'#9ca3af' }}>{label}</div>
    </div>
  );
}

function RoleBox({ title, children }) {
  return (
    <div style={{ padding:12, border:'1px solid rgba(255,255,255,0.10)', background:'rgba(255,255,255,0.03)', borderRadius:10 }}>
      <div style={{ fontWeight:700, color:'#E5E7EB', marginBottom:6 }}>{title}</div>
      <div style={{ fontSize:13, color:'#cbd5e1', lineHeight:1.6 }}>{children}</div>
    </div>
  );
}